<template>
  <LoadingScreen id="loading-screen" />
  <Navbar />
  <div class="notifications-container">
    <Notification
      v-for="not in notifications"
      :key="not._id"
      :index="not._id"
      :notIcon="not.status"
      :title="not.from"
      :to="not.to"
      :from="not.from"
      :status="not.status"
      :time="not.time"
      :notId="not._id"
      :mode="not.mode"
      :userEmail="userEmail"
    />
  </div>
</template>

<script>
import Notification from "@/components/Notification.vue";
import Navbar from "@/components/Navbar.vue";
import axios from "axios";
import Swal from "sweetalert2";
import LoadingScreen from "@/components/LoadingScreen.vue";

let headers = {};

function setNotifications(self) {
  // let jwt = localStorage.getItem("jwt");
  // headers = {
  //   Authorization: "Bearer " + jwt,
  // };
  axios
    .get(`${process.env.VUE_APP_BACKEND}/messages/`, {
      headers: headers,
    })
    .then(function (res) {
      if (res.data.length > 0) {
        self.notifications = res.data;

        let pendingNotifications = res.data.filter(function (item) {
          return item.status == "Pending";
        }).length;
        if (pendingNotifications > 0) {
          document.title = `(${pendingNotifications}) ${document.title}`;
        }
      } else {
        let notContainer = document.querySelector(".notifications-container");
        notContainer.innerHTML = "";
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom-right",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "error",
          title:
            "Sorry... No notifications found. You will soon be redirected back to the home page.",
        }).then(() => {
          if (self.$router.currentRoute.value.fullPath == "/notifications") {
            self.$router.push("/");
          }
        });
      }
      setTimeout(() => {
        let loadingScreen = document.querySelector("#loading-screen");
        loadingScreen.classList.add("fade-out");
      }, 1000);
    })
    .catch(function (err) {
      Swal.fire("Error", `${err}`, "error");
    });
}

export default {
  name: "Notifications",
  components: {
    Notification,
    Navbar,
    LoadingScreen,
  },
  data() {
    return {
      notifications: { type: Array, default: [] },
      order: { type: String, default: "" },
      userEmail: "",
    };
  },
  mounted() {
    let title = "Notifications - Dating4Pets";
    document.title = title;

    let self = this;
    let jwt = localStorage.getItem("jwt");
    if (jwt == null) {
      self.$router.push("/");
    }

    headers = {
      Authorization: "Bearer " + jwt,
    };

    axios
      .get(`${process.env.VUE_APP_BACKEND}/users/info`, { headers: headers })
      .then((res) => {
        self.userEmail = res.data.email;
        setNotifications(self);
      })
      .catch((err) => {
        console.error(err);
        self.$router.push("/");
      });
  },
};
</script>

<style>
.notifications-container {
  align-self: flex-start;
  margin-top: 5em;
  overflow: visible;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#empty-msg {
  font-size: 5em;
  font-weight: bolder;
  text-shadow: -0.03em 0.03em hsl(0, 0%, 51%), -0.06em 0.06em hsl(0, 0%, 76%),
    -0.09em 0.09em hsl(0, 0%, 100%);
}
</style>
